module.exports = __webpack_public_path__ + "assets/75668079d477cfa3ab4d6d40fd363aab.png";